import { useState } from 'react';
import axios from 'axios';

const useUpdateIaTraining = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const updateIaTraining = async (cis_id, formData) => {
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
    
      const response = await axios.put(`https://niaserver-05287f289508.herokuapp.com/iaTraining/update/${cis_id}`, formData);
      if (response.data.success) {
        setSuccess(true);
      } else {
        setError(response.data.error || 'Error updating profile.');
      }
    } catch (error) {
      setError('Error: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    success,
    updateIaTraining,
  };
};

export default useUpdateIaTraining;
